import React, { useState } from "react";
import { ArrowUpOutlined } from "@ant-design/icons";
import brandOImg from "../../assets/logo/o.png";

function Footer({ openTrialSignup }) {
  const currentYear = new Date().getFullYear();
  const [isHovering, setIsHovering] = useState(false);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  const handleAction = () => {
    if (typeof openTrialSignup === "function") {
      openTrialSignup("Footer Inquiry");
    } else {
      window.location.href = "mailto:support@dealvoicecrm.com";
    }
  };

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  return (
    <footer
      className="landing-footer-section"
      id="about"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onMouseMove={handleMouseMove}
      onClick={handleAction}
    >
      {/* Magnetic Floating "Get in Touch" Cursor */}
      <div
        className={`footer-floating-cursor ${isHovering ? "active" : ""}`}
        style={{
          left: `${mousePos.x}px`,
          top: `${mousePos.y}px`,
        }}
        aria-hidden="true"
      >
        <div className="floating-cursor-inner">
          <span className="floating-cursor-text">Get in Touch</span>
          <ArrowUpOutlined className="floating-cursor-arrow" />
        </div>
      </div>

      <div className="landing-footer-container">
        {/* BIG STATEMENT: GET IN T(o.png)UCH */}
        <div className="get-in-touch-wrapper">
          <span className="get-in-touch-text">GET IN T</span>
          <div
            className="get-in-touch-circle-btn"
            aria-label="DealVoice"
          >
            <img
              src={brandOImg}
              alt="DealVoice O"
              className="get-in-touch-logo-img"
            />
          </div>
          <span className="get-in-touch-text">UCH</span>
        </div>

        {/* FOOTER BOTTOM BAR: COPYRIGHT (LEFT) & CRM LEGAL/COMPLIANCE LINKS (RIGHT) */}
        <div
          className="footer-bottom-bar"
          onClick={(e) => e.stopPropagation()}
          onMouseEnter={(e) => {
            e.stopPropagation();
            setIsHovering(false);
          }}
          onMouseLeave={(e) => {
            e.stopPropagation();
            setIsHovering(true);
          }}
          onMouseMove={(e) => e.stopPropagation()}
        >
          <p className="footer-copyright">
            © {currentYear} DealVoice. All rights reserved.
          </p>

          <div className="footer-legal-links">
            <a href="#privacy" className="footer-legal-link">
              Privacy Policy
            </a>
            <span className="footer-link-divider">•</span>
            <a href="#terms" className="footer-legal-link">
              Terms of Service
            </a>
            <span className="footer-link-divider">•</span>
            <a href="#security" className="footer-legal-link">
              Security & Compliance
            </a>
            <span className="footer-link-divider">•</span>
            <a href="#gst" className="footer-legal-link">
              GST & Invoicing Policy
            </a>
            <span className="footer-link-divider">•</span>
            <a href="#cookies" className="footer-legal-link">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
